import * as React from 'react'

function SvgPlayerSubtitleFill(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M21 5a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h18zM8.73 9C7.075 9 6 10.352 6 12.503 6 14.686 7.075 16 8.741 16c1.43 0 2.413-.99 2.52-2.494H10c-.124.761-.565 1.218-1.242 1.218-.849 0-1.397-.812-1.397-2.22 0-1.384.543-2.222 1.386-2.222.715 0 1.14.54 1.247 1.257h1.263C11.166 10.123 10.236 9 8.73 9zm6.738 0c-1.655 0-2.73 1.352-2.73 3.503 0 2.183 1.075 3.497 2.741 3.497 1.43 0 2.414-.99 2.521-2.494h-1.263c-.124.761-.564 1.218-1.242 1.218-.849 0-1.397-.812-1.397-2.22 0-1.384.543-2.222 1.387-2.222.714 0 1.14.54 1.247 1.257h1.263C17.903 10.123 16.973 9 15.468 9z"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default SvgPlayerSubtitleFill
